export const ModalWindowContent = Object.freeze({
  contentPadding: 'px-2 pb-3',
  contentLabelStyle: 'block mb-1 ml-1 text-base font-medium text-gray-300',
})

export const CommonStyles = Object.freeze({
  inputStyles:
    'border text-sm rounded-lg block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500',
  inputStylesDisabled:
    'border text-sm rounded-lg block w-full p-2.5 bg-gray-900 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500',
})

export const iconExpanded16 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="inline align-text-bottom feather feather-arrow-down"
  >
    <line x1="8" y1="3" x2="8" y2="12"></line>
    <polyline points="13 8 8 12 3 8"></polyline>
  </svg>
)
export const iconCollapsed16 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="inline align-text-bottom feather feather-arrow-up"
  >
    <line x1="8" y1="3" x2="8" y2="13"></line>
    <polyline points="3 8 8 3 13 8"></polyline>
  </svg>
)
export const iconExpanded24 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="inline align-text-bottom feather feather-arrow-down"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 19 5 12"></polyline>
  </svg>
)
export const iconCollapsed24 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="inline align-text-bottom feather feather-arrow-up"
  >
    <line x1="12" y1="19" x2="12" y2="5"></line>
    <polyline points="5 12 12 5 19 12"></polyline>
  </svg>
)
